var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"font-weight-bold grey--text text--darken-5 text--center dispay-1"},[_vm._v("Have a Good Day...")])}
var staticRenderFns = []

export { render, staticRenderFns }